import {
    Modal,
    ModalDialog,
    ModalClose,
    Typography,
    Stack,
    List,
    ListItem,
    Link
} from "@mui/joy"

export default function SelecaoItem(props) {
    return (
        <Modal open={props.openModalListaItem} onClose={() => props.setOpenModalListaItem(false)}>
            <ModalDialog
                variant={"plain"}
            >
                <ModalClose />
                <Typography
                    id="basic-list-demo"
                    level="body-xs"
                    textTransform="uppercase"
                    fontWeight="lg"
                    fontSize={"18px"}
                >
                    Escolha um item
                </Typography>

                <Stack marginTop={"20px"} sx={{ overflow: "auto", height: "50%" }}>
                    <List>
                        {props.itensEncontradosBusca.map(function (item) {
                            return (
                                <ListItem sx={{ borderBottom: 1, borderColor: "#ddd", marginBottom: "5px" }} onClick={() => [props.novoItem(item.CODIGOPRD), props.setOpenModalListaItem(false)]}>
                                    <Link fontSize={"16px"}>{item.CODIGOPRD} - {item.NOMEFANTASIA}</Link>
                                </ListItem>
                            )
                        })}
                    </List>
                </Stack>
            </ModalDialog>
        </Modal>
    )
}